import { Loadable } from 'components/common';
import { lazy, useEffect } from 'react';
import { InView } from 'react-intersection-observer';
import { Button, Spin } from 'antd';
import { ArrowDownIcon } from 'assets';
import { useDispatch } from 'react-redux';
import { useAIAgentCallChatContext } from 'contexts/ai-agent-center';
const AIAgentCallMessageList = lazy(() => import('./AIAgentCallMessageList'));

type AIAgentCallMessageBoxProps = {};
interface CustomerSupportSessionState {
  callSessionId?: number;
  searchData?: searchData[];
  callId?: string;
}

interface searchData {
  key: string;
  label: string;
  customerId: number;
  customerCode: string;
  minimizedModals: number[]; // Lưu các modal đã thu nhỏ
  formData: { [key: number]: any }; // Lưu dữ liệu form của từng modal
}

const AIAgentCallMessageBox: React.FC<AIAgentCallMessageBoxProps> = () => {
  const {
    positions,
    messagesBoxRef,
    messageListRef,
    messages,
    hasMore,
    hasNew,
    onGetOlderMess,
    onGetNewerMess,
    isAtBottomScroll,
    scrollToEndMessage,
    isFetching,
    isLoading,
    callSession
  } = useAIAgentCallChatContext();
  const dispatch = useDispatch();

  return (
    <div className='relative flex-grow overflow-hidden'>
      <Spin
        prefixCls='spin-ai-agent-call-chat'
        delay={3000}
        spinning={isFetching || isLoading}
        wrapperClassName='max-h-full h-full'
        className='h-full'
      >
        <div
          ref={messagesBoxRef}
          className='fade-scrollbar h-full'
          style={{
            overflowY: 'auto'
          }}
        >
          <div ref={messageListRef} className='relative min-h-full w-full overflow-hidden px-5'>
            {hasMore ? (
              <InView
                className='absolute h-10 w-full'
                style={{
                  top: positions[5]?.position,
                  height: positions[5]?.height
                }}
                as='div'
                onChange={(inView) => {
                  if (inView) {
                    onGetOlderMess();
                  }
                }}
              />
            ) : null}

            {hasNew ? (
              <InView
                className='absolute h-10 w-full'
                as='div'
                style={{
                  top: positions[positions.length - 5]?.position,
                  height: positions[positions.length - 5]?.height
                }}
                onChange={(inView) => {
                  if (inView) {
                    onGetNewerMess();
                  }
                }}
              />
            ) : null}
            <Loadable>
              <AIAgentCallMessageList messages={messages} />
            </Loadable>
          </div>
        </div>
        {!isAtBottomScroll && (
          <div className='absolute bottom-4 left-1/2 z-50 -translate-x-1/2'>
            <Button onClick={scrollToEndMessage} className='h-8 w-8' shape='circle' icon={<ArrowDownIcon />}></Button>
          </div>
        )}
      </Spin>
    </div>
  );
};

export default AIAgentCallMessageBox;
